// src/config/sensorMapping.js

// Map sensor index (1-64) to coordinate point
export const SENSOR_INDEX_TO_COORDINATE = {
  // Index: { x: coordinate_x, y: coordinate_y }
  1: { x: 20.25, y: 73.75 },
  2: { x: 22.75, y: 58.05 },
  3: { x: 22.75, y: 45.55 },
  4: { x: 20.25, y: 33.05 },
  5: { x: 17.75, y: 20.55 },
  6: { x: 15.25, y: 8.05 },
  7: { x: 15.25, y: -3.75 },
  8: { x: 12.75, y: -9.45 },

  9: { x: 7.75, y: 71.917123 },
  10: { x: 7.75, y: 58.05 },
  11: { x: 7.75, y: 45.55 },
  12: { x: 7.75, y: 33.05 },
  13: { x: 5.25, y: 20.55 },
  14: { x: 5.25, y: 8.05 },
  15: { x: 5.25, y: -3.75 },
  16: { x: 5.25, y: -11.25 },

  17: { x: -7.25, y: 71.917123 },
  18: { x: -7.25, y: 58.05 },
  19: { x: -7.25, y: 45.55 },
  20: { x: -7.25, y: 33.05 },
  21: { x: -4.75, y: 20.55 },
  22: { x: -4.75, y: 8.05 },
  23: { x: -4.75, y: -3.75 },
  24: { x: -4.75, y: -11.25 },

  25: { x: -19.75, y: 73.75 },
  26: { x: -22.25, y: 58.05 },
  27: { x: -22.25, y: 45.55 },
  28: { x: -19.75, y: 33.05 },
  29: { x: -17.25, y: 20.55 },
  30: { x: -14.75, y: 8.05 },
  31: { x: -14.75, y: -3.75 },
  32: { x: -12.197028, y: -9.574136 },

  33: { x: -34.75, y: -33.75 },
  34: { x: -22.95, y: -23.75 },
  35: { x: -12.25, y: -26.25 },
  36: { x: -0.45, y: -36.25 },
  37: { x: 0.25, y: -26.25 },
  38: { x: 13.45, y: -26.25 },
  39: { x: 25.25, y: -23.75 },
  40: { x: 35.25, y: -33.75 },

  41: { x: -45.45, y: -48.75 },
  42: { x: -30.45, y: -43.75 },
  43: { x: -20.45209, y: -38.75 },
  44: { x: -9.75, y: -41.25 },
  45: { x: 8.45, y: -41.25 },
  46: { x: 20.25, y: -38.75 },
  47: { x: 30.25, y: -43.75 },
  48: { x: 45.95, y: -48.75 },

  49: { x: -50.45, y: -63.75 },
  50: { x: -37.95, y: -56.25 },
  51: { x: -22.95, y: -53.382877 },
  52: { x: -6.55, y: -53.75 },
  53: { x: 5.95, y: -53.75 },
  54: { x: 20.25, y: -53.75 },
  55: { x: 35.95, y: -56.25 },
  56: { x: 50.25, y: -63.75 },

  57: { x: -54.05, y: -76.25 },
  58: { x: -42.95, y: -71.25 },
  59: { x: -30.45, y: -66.25 },
  60: { x: -15.45, y: -61.25 },
  61: { x: 13.45, y: -61.25 },
  62: { x: 28.45, y: -66.25 },
  63: { x: 42.57291, y: -72.382877 },
  64: { x: 54.44791, y: -76.25 }
};

// Generate coordinate array in index order (for the chart component)
export const getCoordinatesInOrder = () => {
  const coordinates = [];
  for (let i = 1; i <= 64; i++) {
    if (SENSOR_INDEX_TO_COORDINATE[i]) {
      coordinates.push(SENSOR_INDEX_TO_COORDINATE[i]);
    } else {
      console.warn(`Missing coordinate for sensor index ${i}`);
      coordinates.push({ x: 0, y: 0 }); // Default fallback
    }
  }
  return coordinates;
};

// Helper function to get coordinate by sensor index
export const getCoordinateByIndex = (index) => {
  return SENSOR_INDEX_TO_COORDINATE[index] || { x: 0, y: 0 };
};

// Helper function to validate mapping (ensure all indexes 1-64 are present)
export const validateSensorMapping = () => {
  const missing = [];
  for (let i = 1; i <= 64; i++) {
    if (!SENSOR_INDEX_TO_COORDINATE[i]) {
      missing.push(i);
    }
  }
  
  if (missing.length > 0) {
    console.error(`Missing sensor mappings for indexes: ${missing.join(', ')}`);
    return false;
  }
  
  console.log('✅ All 64 sensor indexes are mapped to coordinates');
  return true;
};

// Static bounds based on the coordinates
export const STATIC_BOUNDS_F = {
  xMin: -60,
  xMax: 60,
  yMin: -100,
  yMax: -20
};

export const STATIC_BOUNDS_B = {
  xMin: -30,
  xMax: 30,
  yMin: -80,
  yMax: 40,
};

export const getStaticBounds = () => {
  return {
    front: STATIC_BOUNDS_F,
    back: STATIC_BOUNDS_B
  };
};

// Verify mapping on import
validateSensorMapping();